import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { useTranslation } from "react-i18next";
import useError from "helpers/hooks/useError";
import useLoading from "helpers/hooks/useLoading";
import ErrorModal from "components/ErrorModal/ErrorModal";
import { ErrorFallback, Footer, Header, Spinner } from "components";
import { ResetLogin } from "redux/slices/LoginSlice";
import { resetOtp } from "redux/slices/OtpSlice";
import { resetMerchant } from "redux/slices/MerchantSlice";
import { resetMenu } from "redux/slices/StepSlice";
import { useAppDispatch } from "redux/hooks";

const HomeScreen = () => {
  const { t } = useTranslation();
  const isLoading = useLoading();
  const dispatch = useAppDispatch();
  let err = useError();
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState<string>("");

  useEffect(() => {
    setIsErrorModalOpen(!!err);
    if (err.startsWith("MRC#")) {
      setErrMsg(err.split("#")[1]);
      dispatch(ResetLogin());
      dispatch(resetOtp());
      dispatch(resetMerchant());
      dispatch(resetMenu());
    } else {
      setErrMsg(err);
    }
  }, [err]);

  return (
    <>
      {isErrorModalOpen && (
        <ErrorModal
          acceptButtonText={t("modal_error_button_title").toString()}
          message=''
          setIsOpen={setIsErrorModalOpen}
          title={t("modal_error_title").toString()}
        >
          <ErrorFallback error={errMsg} fontSize='16px' />
        </ErrorModal>
      )}

      <Spinner show={isLoading} />
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default HomeScreen;
